import TabPanel from "../TabPanel";
import EquipmentManagement from "./EquipmentManagement";
import { SettingsModalTabProps } from "../types";

const EquipmentManagementTab: React.FC<SettingsModalTabProps> = ({ parentTab, index }) => {
  return (
    <TabPanel value={parentTab} index={index} paddingX={1} height={"calc(100vh - 110px)"}>
      <EquipmentManagement />
    </TabPanel>
  )
}
export default EquipmentManagementTab;
